module.exports = __webpack_public_path__ + "static/media/icon_inbox_validacion.389c15e4.svg";